import { createAction, props } from '@ngrx/store';
import { Currency } from '@rx-applications/shared/data-access';

export const loadCurrencyList = createAction('[Currency] Load Currency List');

export const loadCurrencyListSucceed = createAction(
  '[Currency] Currency List Load Succeed',
  props<{ payload: Currency[] }>()
);

export const loadCurrencyListFailed = createAction('[Currency] Currency List Load Failed');

export const setCurrentCurrency = createAction('[Currency] Set Current Currency', props<{ payload: string }>());
